// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__iJ_z-","col":"styles_col__1rDWJ","fulfillmentStatus":"styles_fulfillmentStatus__1XY3N","emailCol":"styles_emailCol__3kt6O"};